// ボタン左右揃え用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var RowLeftAndRightAlignmentButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Row, { className: "row-left-and-right-alignment-buttons" },
        React.createElement(Col, { className: "text-left-and-right" }, children)));
};
export default RowLeftAndRightAlignmentButton;
